import React, { useState } from "react";
import { Col, Row } from "react-bootstrap";
import { FormattedMessage } from "react-intl";
import ImageUpload from "components/shared/ImageUpload";
import removeImg from "assets/svgs/close.svg";

const ServiceItem = ({ item, index, onRemove, onChange }) => {
  const [selectedImage, setSelectedImage] = useState({
    preview: null,
    path: item.image || "",
  });

  const handleFeatureAdd = () => {
    const newFeatures = [...(item.features || []), { ar: "", en: "" }];
    onChange(index, { ...item, features: newFeatures });
  };

  const handleFeatureRemove = (featureIndex) => {
    const newFeatures = item.features.filter((_, i) => i !== featureIndex);
    onChange(index, { ...item, features: newFeatures });
  };

  const handleFeatureChange = (featureIndex, field, value) => {
    const newFeatures = [...item.features];
    newFeatures[featureIndex] = {
      ...newFeatures[featureIndex],
      [field]: value,
    };
    onChange(index, { ...item, features: newFeatures });
  };

  const handleChange = (field, value) => {
    if (field === "image" && selectedImage.path) {
      onChange(index, { ...item, image: selectedImage.path });
    } else {
      onChange(index, { ...item, [field]: value });
    }
  };

  return (
    <div className="add-multi-component">
      <button
        type="button"
        onClick={() => onRemove(index)}
        className="removeImg"
        aria-label="Remove service"
      >
        <img src={removeImg} alt="Remove service" />
      </button>
      <Row>
        <Col lg={12}>
          <ImageUpload
            selectedImage={selectedImage}
            setSelectedImage={(newImage) => {
              setSelectedImage(newImage);
              if (newImage.path) {
                handleChange("image", newImage.path);
              }
            }}
            defaultImage={item.image || ""}
            label={<FormattedMessage id="image" />}
          />
        </Col>

        <Col lg={6}>
          <div className="form-group">
            <h5>
              <FormattedMessage id="title" /> ({" "}
              <FormattedMessage id="arabic-language" /> )
            </h5>
            <input
              type="text"
              className="form-control"
              value={item.title?.ar || ""}
              onChange={(e) =>
                handleChange("title", { ...item.title, ar: e.target.value })
              }
              style={{
                backgroundColor: "#fff",
              }}
            />
          </div>
        </Col>

        <Col lg={6}>
          <div className="form-group">
            <h5>
              <FormattedMessage id="title" /> ({" "}
              <FormattedMessage id="english-language" /> )
            </h5>
            <input
              type="text"
              className="form-control"
              value={item.title?.en || ""}
              onChange={(e) =>
                handleChange("title", { ...item.title, en: e.target.value })
              }
              style={{
                backgroundColor: "#fff",
              }}
            />
          </div>
        </Col>

        <Col lg={6}>
          <div className="form-group">
            <h5>
              <FormattedMessage id="description" /> ({" "}
              <FormattedMessage id="arabic-language" /> )
            </h5>
            <textarea
              className="form-control"
              value={item.description?.ar || ""}
              onChange={(e) =>
                handleChange("description", {
                  ...item.description,
                  ar: e.target.value,
                })
              }
              style={{
                backgroundColor: "#fff",
              }}
            />
          </div>
        </Col>

        <Col lg={6}>
          <div className="form-group">
            <h5>
              <FormattedMessage id="description" /> ({" "}
              <FormattedMessage id="english-language" /> )
            </h5>
            <textarea
              className="form-control"
              value={item.description?.en || ""}
              onChange={(e) =>
                handleChange("description", {
                  ...item.description,
                  en: e.target.value,
                })
              }
              style={{
                backgroundColor: "#fff",
              }}
            />
          </div>
        </Col>

        <Col lg={12}>
          <div className="form-group features">
            <h5 className="d-flex justify-content-between align-items-center">
              <FormattedMessage id="features" />
              <button
                type="button"
                className="btn btn-blue"
                onClick={handleFeatureAdd}
                style={{
                  display: "inline-flex",
                  alignItems: "center",
                  justifyContent: "center",
                  width: "auto",
                }}
              >
                <FormattedMessage id="addFeature" />
              </button>
            </h5>
            {item.features?.map((feature, featureIndex) => (
              <div
                key={featureIndex}
                className="add-multi-component"
                style={{
                  backgroundColor: "#fff",
                }}
              >
                <button
                  type="button"
                  onClick={() => handleFeatureRemove(featureIndex)}
                  className="removeImg"
                  aria-label="Remove feature"
                >
                  <img src={removeImg} alt="Remove feature" />
                </button>
                <Row>
                  <Col lg={6}>
                    <div className="form-group">
                      <h5>
                        <FormattedMessage id="feature" /> ({" "}
                        <FormattedMessage id="arabic-language" /> )
                      </h5>
                      <input
                        type="text"
                        className="form-control"
                        value={feature.ar || ""}
                        onChange={(e) =>
                          handleFeatureChange(
                            featureIndex,
                            "ar",
                            e.target.value
                          )
                        }
                      />
                    </div>
                  </Col>
                  <Col lg={6}>
                    <div className="form-group">
                      <h5>
                        <FormattedMessage id="feature" /> ({" "}
                        <FormattedMessage id="english-language" /> )
                      </h5>
                      <input
                        type="text"
                        className="form-control"
                        value={feature.en || ""}
                        onChange={(e) =>
                          handleFeatureChange(
                            featureIndex,
                            "en",
                            e.target.value
                          )
                        }
                      />
                    </div>
                  </Col>
                </Row>
              </div>
            ))}
          </div>
        </Col>
      </Row>
    </div>
  );
};

export default ServiceItem;
